<!--
 * @Descripttion: 
 * @version: 1.0
 * @Author: Erik Zhang
 * @Date: 2021-04-05 15:18:58
 * @LastEditors: Erik Zhang
 * @LastEditTime: 2021-04-06 20:03:54
-->
<!--
 * @Descripttion: 
 * @version: 1.0
 * @Author: Erik Zhang
 * @Date: 2021-02-14 23:36:16
 * @LastEditors: Erik Zhang
 * @LastEditTime: 2021-04-05 15:50:58
-->
<template>
  <edu-layout type="table">
    <veHqHaopinCr viewType="chu" slot="table"></veHqHaopinCr>
  </edu-layout>
</template>

<script>
import veHqHaopinCr from './base/veHqHaopinCr';
export default {
  components: {
    veHqHaopinCr
  },
  data() {
    return {};
  },
  mounted() {},
  methods: {}
};
</script>
<style lang="less" scoped></style>
